/*
 * @Author: hejianbo
 * @Date: 2022-03-14 09:48:15
 * @FilePath: \MCN_new\app\main\backstage\ugcManage\userContribution\userContributionDetails\userContributionDetails.js
 * @Description: 
 */
/**
 * 首页
 * 2017-12-6
 */
'use strict';
angular.module('userContributionDetailsModule', ['userContributionDetailsRouter']).controller('userContributionDetailsCtrl', [
    '$scope',
    'httpService',
    '$filter',
    '$stateParams',
    'modalDialog',
    '$sce',
    function ($scope, httpService, $filter, $stateParams, modalDialog, $sce) {
        initStatus();
        initData();
        /**
         * [initStatus description] 初始化参数
         */
        function initStatus() {
            $scope.status = {
                isBackstage: true //区分后台和前台
            };
            $scope.listData = [];
            $scope.page = {
                CURRPAGE: 0,
                PAGESIZE: 10,
                ITEMCOUNT: 0
            };
            $scope.params = {
                id: $stateParams.articleId,
                articleType: 0
            };
            $scope.data = {
                firstClassic: '',
                secondClassic: '',
                remark: ''
            };
        }
        /**
         * [initStatus description] 初始化数据
         */
        function initData() {
            $('html').css('backgroundColor', '#F5F7FA');
            requestData();
        }
        /**
         * [requestData description] 初始化列表数据
         */
        function requestData() {
            $scope.loadingPromise = httpService.http('/mcnadmin/admin/article/findById.do', $scope.params, 'get').then(function (data) {
                $scope.listData = data.data;
                $scope.listData.articleHtmlCon = $sce.trustAsHtml(data.data.articleHtmlCon);
                $scope.data.firstClassic = data.firstClassic.departName;
                $scope.data.secondClassic = data.secondClassic.departName;
                $scope.data.remark = data.data.remark;
                $scope.status.picUrlList = data.picUrlList;
                $scope.status.videoUrl = data.videoUrlList.length ? data.videoUrlList[0].url : '';
            });
        }
    }
]);
